export default __webpack_public_path__ + "static/media/docum.7c46baa3.svg";